export default __webpack_public_path__ + "static/media/component221.ba079360.png";